import { useRouterStore } from '@/store-pinia/router';
import routesRaw from '@/store-pinia/router/routesRaw';

export default function () {
  useRouterStore().routes = routesRaw;
}
